import { Capacitor } from '@capacitor/core'

export const isElectron = Capacitor.getPlatform() === 'electron'
